/* USAGS Community - YouTube feed. Shared by sections/usags-community-youtube.liquid and the Videos block of
   sections/usags-community-hub.liquid. Any element with [data-cm-yt] gets the newest uploads from the
   YouTube Data API v3 (key in data-key), cached in the visitor's browser so quota use stays tiny.
   Videos show as thumbnails and only load the player on click. */
(function () {
  var API = 'https://www.googleapis.com/youtube/v3/';
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML.replace(/"/g, '&quot;'); }
  function getJSON(url) { return fetch(url).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }); }

  function play(e) {
    var btn = e.target.closest('[data-cm-yt-play]');
    if (!btn || btn.querySelector('iframe')) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(btn.getAttribute('data-cm-yt-play')) + '?autoplay=1&rel=0';
    f.title = btn.getAttribute('aria-label') || 'YouTube video';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    f.allowFullscreen = true;
    btn.appendChild(f);
  }

  function init(root) {
    if (root.dataset.cmInit) return;
    root.dataset.cmInit = '1';
    root.addEventListener('click', play);
    var grid = root.querySelector('[data-cm-yt-grid]');
    var key = root.dataset.key, count = parseInt(root.dataset.count, 10) || 6;
    if (!grid || !key || grid.querySelector('[data-cm-yt-play]')) return; // no key, or pinned videos override the feed
    var hideShorts = root.dataset.shorts === 'true';
    var cacheMs = (parseFloat(root.dataset.cache) || 6) * 3600000;
    var handle = root.dataset.handle || '@USAGundamTV';
    var chId = (root.dataset.channel || '').trim();
    var cacheKey = 'usagsYT2:' + (chId || handle) + ':' + count + ':' + hideShorts;

    function render(items) {
      if (!items || !items.length) { root.hidden = true; return; }
      var dfmt = { month: 'short', day: 'numeric', year: 'numeric' };
      grid.innerHTML = items.map(function (v) {
        var d = v.date ? new Date(v.date).toLocaleDateString('en-US', dfmt) : '';
        return '<div class="usags-cm-yt__item">' +
          '<button type="button" class="usags-cm-yt__player" data-cm-yt-play="' + esc(v.id) + '" aria-label="Play ' + esc(v.title) + '">' +
          '<img src="' + esc(v.thumb) + '" alt="" loading="lazy" width="480" height="360">' +
          '<span class="usags-cm-yt__play"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4.5v15l13-7.5z"/></svg></span></button>' +
          '<div class="usags-cm-yt__title">' + esc(v.title) + '</div>' +
          (d ? '<div class="usags-cm-yt__date">' + d + '</div>' : '') + '</div>';
      }).join('');
    }

    try {
      var c = JSON.parse(localStorage.getItem(cacheKey) || 'null');
      if (c && c.t && Date.now() - c.t < cacheMs && c.items && c.items.length) { render(c.items); return; }
    } catch (e) {}

    var uploadsP = chId.indexOf('UC') === 0
      ? Promise.resolve('UU' + chId.slice(2))
      : getJSON(API + 'channels?part=contentDetails&forHandle=' + encodeURIComponent(handle) + '&key=' + key)
          .then(function (j) { return j.items && j.items[0] && j.items[0].contentDetails.relatedPlaylists.uploads; });

    uploadsP.then(function (pl) {
      if (!pl) throw new Error('channel not found');
      var max = hideShorts ? 50 : Math.min(50, count); // Shorts are filtered out after, so pull a full page
      return getJSON(API + 'playlistItems?part=snippet,contentDetails&maxResults=' + max + '&playlistId=' + pl + '&key=' + key);
    }).then(function (j) {
      var vids = (j.items || []).filter(function (it) {
        var t = it.snippet && it.snippet.title;
        return t && t !== 'Private video' && t !== 'Deleted video';
      });
      if (!hideShorts || !vids.length) return vids;
      var ids = vids.map(function (v) { return v.contentDetails.videoId; }).join(',');
      return getJSON(API + 'videos?part=contentDetails&id=' + ids + '&key=' + key).then(function (vj) {
        var long = {};
        (vj.items || []).forEach(function (x) {
          var m = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/.exec(x.contentDetails.duration) || [];
          if ((+m[1] || 0) * 3600 + (+m[2] || 0) * 60 + (+m[3] || 0) > 180) long[x.id] = true;
        });
        return vids.filter(function (v) { return long[v.contentDetails.videoId]; });
      });
    }).then(function (vids) {
      var items = vids.slice(0, count).map(function (it) {
        var s = it.snippet, th = s.thumbnails || {}, t = th.high || th.medium || th.default || {};
        return { id: it.contentDetails.videoId, title: s.title, date: it.contentDetails.videoPublishedAt || s.publishedAt, thumb: t.url || '' };
      });
      try { localStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
      render(items);
    }).catch(function (err) {
      if (window.console) console.warn('[USAGS YouTube]', err);
      root.hidden = true;
    });
  }

  function run() { document.querySelectorAll('[data-cm-yt]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
